import AdvancedController from "./advanced-controller"
import { gsap } from 'gsap'

export default class ToggleController extends AdvancedController {

  static targets = ['content' ];

  static classes = [ "active" ]

  _isOpen = false

  onToggleClick(e) {
    e.preventDefault();
    this._isOpen = !this._isOpen
    if (this._isOpen) {
      this._open();
    } else {
      this._close();
    }
  }

  _open() {
    this.element.classList.add(this.activeClass)
    
    this.contentTarget.style.display = 'block'
    this.contentTarget.style.height = 'auto'
    const h = this.contentTarget.offsetHeight

    gsap.fromTo(this.contentTarget, { height: '0px' }, { height: `${h}px`})

  }

  _close() {
    this.element.classList.remove(this.activeClass)

    const h = this.contentTarget.offsetHeight
    gsap.fromTo(this.contentTarget, { height: `${h}px`}, { height: '0px', onComplete: () => (this.contentTarget.style.display = "none") })
  }

}
